import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { TransitionService, UIRouterModule } from '@uirouter/angular';

import { NavigateBackDirective } from '@app/shared/modules/navigate-back/navigate-back.directive';
import { NavigateBackService } from './navigate-back.service';

@NgModule({
  imports: [CommonModule, UIRouterModule.forChild()],
  declarations: [NavigateBackDirective],
  exports: [NavigateBackDirective],
  providers: [NavigateBackService]
})
export class NavigateBackModule {
  constructor() {
    const transitions = inject(TransitionService, { optional: true })!;
    const navigateBackService = inject(NavigateBackService, { optional: true })!;

    if (!transitions) {
      return;
    }

    transitions.onSuccess({}, transition => {
      const from = transition.$from();
      if (from.name) {
        navigateBackService.pushState({
          name: from.name,
          params: transition.params('from')
        });
      }
    });
  }
}
